import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Key14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      d='M5.00002 4.99999C5.55231 4.99999 6.00002 4.55228 6.00002 3.99999C6.00002 3.44771 5.55231 2.99999 5.00002 2.99999C4.44774 2.99999 4.00002 3.44771 4.00002 3.99999C4.00002 4.55228 4.44774 4.99999 5.00002 4.99999Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.4948 7.5052C3.32451 8.33492 4.41348 8.74999 5.49998 8.75L6.68372 8.75002L7.22869 9.30903L7.24385 10.5157C7.25244 11.1999 7.80951 11.75 8.49375 11.75H9.24999L9.24999 12.5C9.24999 13.1904 9.80963 13.75 10.5 13.75H12.5C13.1903 13.75 13.75 13.1904 13.75 12.5V10.2071C13.75 9.87561 13.6183 9.55767 13.3839 9.32325L9.75 5.68938V4.50164C9.75041 3.41459 9.33534 2.32493 8.5052 1.4948C6.84548 -0.164932 4.15452 -0.164932 2.4948 1.4948C0.835068 3.15452 0.835068 5.84548 2.4948 7.5052ZM5.5 7.25C4.79505 7.25 4.09257 6.98166 3.55546 6.44454C2.48151 5.3706 2.48151 3.6294 3.55546 2.55546C4.6294 1.48151 6.3706 1.48151 7.44454 2.55546C7.98193 3.09284 8.25027 3.79576 8.25 4.50106L8.25 5.79293C8.25 6.12445 8.38169 6.4424 8.61612 6.67682L12.25 10.3107V12.25H10.75V11.5C10.75 10.8097 10.1903 10.25 9.49999 10.25H8.74063L8.72732 9.19034C8.7233 8.86977 8.59626 8.56301 8.37247 8.33346L7.68419 7.62745C7.44893 7.38613 7.12619 7.25003 6.78917 7.25002L5.5 7.25Z'
      fill='currentColor'
    />
  </Svg>
);

Key14.displayName = 'Key14';
export default Key14;
